/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  DocumentChatSetting,
  DocumentChatSettingFromJSON,
  DocumentChatSettingFromJSONTyped,
  DocumentChatSettingToJSON
} from './DocumentChatSetting'
import { DocumentCta, DocumentCtaFromJSON, DocumentCtaFromJSONTyped, DocumentCtaToJSON } from './DocumentCta'
import {
  DocumentMessage,
  DocumentMessageFromJSON,
  DocumentMessageFromJSONTyped,
  DocumentMessageToJSON
} from './DocumentMessage'
import {
  DocumentMiscSetting,
  DocumentMiscSettingFromJSON,
  DocumentMiscSettingFromJSONTyped,
  DocumentMiscSettingToJSON
} from './DocumentMiscSetting'
import {
  DocumentOpportunity,
  DocumentOpportunityFromJSON,
  DocumentOpportunityFromJSONTyped,
  DocumentOpportunityToJSON
} from './DocumentOpportunity'
import { DocumentShare, DocumentShareFromJSON, DocumentShareFromJSONTyped, DocumentShareToJSON } from './DocumentShare'
import { DocumentSlide, DocumentSlideFromJSON, DocumentSlideFromJSONTyped, DocumentSlideToJSON } from './DocumentSlide'
import {
  EnumDocumentSlideProcessingStatus,
  EnumDocumentSlideProcessingStatusFromJSON,
  EnumDocumentSlideProcessingStatusFromJSONTyped,
  EnumDocumentSlideProcessingStatusToJSON
} from './EnumDocumentSlideProcessingStatus'
import {
  EnumPublicationStatus,
  EnumPublicationStatusFromJSON,
  EnumPublicationStatusFromJSONTyped,
  EnumPublicationStatusToJSON
} from './EnumPublicationStatus'
import {
  EnumSharingStatus,
  EnumSharingStatusFromJSON,
  EnumSharingStatusFromJSONTyped,
  EnumSharingStatusToJSON
} from './EnumSharingStatus'
import { Label, LabelFromJSON, LabelFromJSONTyped, LabelToJSON } from './Label'
import {
  StatisticObject,
  StatisticObjectFromJSON,
  StatisticObjectFromJSONTyped,
  StatisticObjectToJSON
} from './StatisticObject'
import { UploadedFile, UploadedFileFromJSON, UploadedFileFromJSONTyped, UploadedFileToJSON } from './UploadedFile'
import {
  UserForDisplay,
  UserForDisplayFromJSON,
  UserForDisplayFromJSONTyped,
  UserForDisplayToJSON
} from './UserForDisplay'

/**
 *
 * @export
 * @interface Document
 */
export interface Document {
  /**
   *
   * @type {string}
   * @memberof Document
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof Document
   */
  organizationId?: string
  /**
   *
   * @type {string}
   * @memberof Document
   */
  documentFolderId?: string | null
  /**
   *
   * @type {string}
   * @memberof Document
   */
  title?: string
  /**
   *
   * @type {string}
   * @memberof Document
   */
  description?: string | null
  /**
   *
   * @type {string}
   * @memberof Document
   */
  memo?: string | null
  /**
   *
   * @type {string}
   * @memberof Document
   */
  label?: string | null
  /**
   *
   * @type {string}
   * @memberof Document
   */
  publishedAt?: string | null
  /**
   *
   * @type {boolean}
   * @memberof Document
   */
  isPublished?: boolean
  /**
   *
   * @type {EnumSharingStatus}
   * @memberof Document
   */
  sharingStatus?: EnumSharingStatus
  /**
   *
   * @type {EnumPublicationStatus}
   * @memberof Document
   */
  publicationStatus?: EnumPublicationStatus
  /**
   *
   * @type {Array<Label>}
   * @memberof Document
   */
  labels?: Array<Label>
  /**
   *
   * @type {UploadedFile}
   * @memberof Document
   */
  thumbnail?: UploadedFile | null
  /**
   *
   * @type {UploadedFile}
   * @memberof Document
   */
  largeThumbnail?: UploadedFile | null
  /**
   *
   * @type {DocumentSlide}
   * @memberof Document
   */
  currentSlide?: DocumentSlide | null
  /**
   *
   * @type {EnumDocumentSlideProcessingStatus}
   * @memberof Document
   */
  slideProcessingStatus?: EnumDocumentSlideProcessingStatus
  /**
   *
   * @type {UserForDisplay}
   * @memberof Document
   */
  user?: UserForDisplay
  /**
   *
   * @type {UserForDisplay}
   * @memberof Document
   */
  createdBy?: UserForDisplay
  /**
   *
   * @type {UserForDisplay}
   * @memberof Document
   */
  updatedBy?: UserForDisplay
  /**
   *
   * @type {string}
   * @memberof Document
   */
  archivedAt?: string | null
  /**
   *
   * @type {string}
   * @memberof Document
   */
  createdAt?: string
  /**
   *
   * @type {string}
   * @memberof Document
   */
  updatedAt?: string
  /**
   *
   * @type {DocumentCta}
   * @memberof Document
   */
  documentCta?: DocumentCta
  /**
   *
   * @type {DocumentOpportunity}
   * @memberof Document
   */
  documentOpportunity?: DocumentOpportunity
  /**
   *
   * @type {DocumentMessage}
   * @memberof Document
   */
  documentMessage?: DocumentMessage
  /**
   *
   * @type {DocumentChatSetting}
   * @memberof Document
   */
  documentChatSetting?: DocumentChatSetting
  /**
   *
   * @type {DocumentShare}
   * @memberof Document
   */
  documentShare?: DocumentShare
  /**
   *
   * @type {DocumentMiscSetting}
   * @memberof Document
   */
  documentMiscSetting?: DocumentMiscSetting
  /**
   *
   * @type {StatisticObject}
   * @memberof Document
   */
  statisticObject?: StatisticObject
}

export function DocumentFromJSON(json: any): Document {
  return DocumentFromJSONTyped(json, false)
}

export function DocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Document {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    organizationId: !exists(json, 'organization_id') ? undefined : json['organization_id'],
    documentFolderId: !exists(json, 'document_folder_id') ? undefined : json['document_folder_id'],
    title: !exists(json, 'title') ? undefined : json['title'],
    description: !exists(json, 'description') ? undefined : json['description'],
    memo: !exists(json, 'memo') ? undefined : json['memo'],
    label: !exists(json, 'label') ? undefined : json['label'],
    publishedAt: !exists(json, 'published_at') ? undefined : json['published_at'],
    isPublished: !exists(json, 'is_published') ? undefined : json['is_published'],
    sharingStatus: !exists(json, 'sharing_status') ? undefined : EnumSharingStatusFromJSON(json['sharing_status']),
    publicationStatus: !exists(json, 'publication_status')
      ? undefined
      : EnumPublicationStatusFromJSON(json['publication_status']),
    labels: !exists(json, 'labels') ? undefined : (json['labels'] as Array<any>).map(LabelFromJSON),
    thumbnail: !exists(json, 'thumbnail') ? undefined : UploadedFileFromJSON(json['thumbnail']),
    largeThumbnail: !exists(json, 'large_thumbnail') ? undefined : UploadedFileFromJSON(json['large_thumbnail']),
    currentSlide: !exists(json, 'current_slide') ? undefined : DocumentSlideFromJSON(json['current_slide']),
    slideProcessingStatus: !exists(json, 'slide_processing_status')
      ? undefined
      : EnumDocumentSlideProcessingStatusFromJSON(json['slide_processing_status']),
    user: !exists(json, 'user') ? undefined : UserForDisplayFromJSON(json['user']),
    createdBy: !exists(json, 'created_by') ? undefined : UserForDisplayFromJSON(json['created_by']),
    updatedBy: !exists(json, 'updated_by') ? undefined : UserForDisplayFromJSON(json['updated_by']),
    archivedAt: !exists(json, 'archived_at') ? undefined : json['archived_at'],
    createdAt: !exists(json, 'created_at') ? undefined : json['created_at'],
    updatedAt: !exists(json, 'updated_at') ? undefined : json['updated_at'],
    documentCta: !exists(json, 'document_cta') ? undefined : DocumentCtaFromJSON(json['document_cta']),
    documentOpportunity: !exists(json, 'document_opportunity')
      ? undefined
      : DocumentOpportunityFromJSON(json['document_opportunity']),
    documentMessage: !exists(json, 'document_message') ? undefined : DocumentMessageFromJSON(json['document_message']),
    documentChatSetting: !exists(json, 'document_chat_setting')
      ? undefined
      : DocumentChatSettingFromJSON(json['document_chat_setting']),
    documentShare: !exists(json, 'document_share') ? undefined : DocumentShareFromJSON(json['document_share']),
    documentMiscSetting: !exists(json, 'document_misc_setting')
      ? undefined
      : DocumentMiscSettingFromJSON(json['document_misc_setting']),
    statisticObject: !exists(json, 'statistic_object') ? undefined : StatisticObjectFromJSON(json['statistic_object'])
  }
}

export function DocumentToJSON(value?: Document | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    organization_id: value.organizationId,
    document_folder_id: value.documentFolderId,
    title: value.title,
    description: value.description,
    memo: value.memo,
    label: value.label,
    published_at: value.publishedAt,
    is_published: value.isPublished,
    sharing_status: EnumSharingStatusToJSON(value.sharingStatus),
    publication_status: EnumPublicationStatusToJSON(value.publicationStatus),
    labels: value.labels === undefined ? undefined : (value.labels as Array<any>).map(LabelToJSON),
    thumbnail: UploadedFileToJSON(value.thumbnail),
    large_thumbnail: UploadedFileToJSON(value.largeThumbnail),
    current_slide: DocumentSlideToJSON(value.currentSlide),
    slide_processing_status: EnumDocumentSlideProcessingStatusToJSON(value.slideProcessingStatus),
    user: UserForDisplayToJSON(value.user),
    created_by: UserForDisplayToJSON(value.createdBy),
    updated_by: UserForDisplayToJSON(value.updatedBy),
    archived_at: value.archivedAt,
    created_at: value.createdAt,
    updated_at: value.updatedAt,
    document_cta: DocumentCtaToJSON(value.documentCta),
    document_opportunity: DocumentOpportunityToJSON(value.documentOpportunity),
    document_message: DocumentMessageToJSON(value.documentMessage),
    document_chat_setting: DocumentChatSettingToJSON(value.documentChatSetting),
    document_share: DocumentShareToJSON(value.documentShare),
    document_misc_setting: DocumentMiscSettingToJSON(value.documentMiscSetting),
    statistic_object: StatisticObjectToJSON(value.statisticObject)
  }
}
